import React, { useState } from 'react';
import { SketchPicker, AlphaPicker } from 'react-color';
import { string, func, bool } from 'prop-types';
import { zipObject, replace, split, map } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ui, uiA, uiCard } from 'envy-ui';

export default function Color({ color='rgba(255,255,255,0)', onChange: onChangeComplete, position='top', tooltip='Set Background', tooltipPosition='top', disableAlpha=false, alphaOnly }) {
  const [showColorPicker, setColorPickerDisplay] = useState(false);

  const onToggle = () => setColorPickerDisplay(!showColorPicker);
  const onClose = () => setColorPickerDisplay(false);

  const popoverPositions = { 'left-center': { right: '25px', top: '-140px' }, 'default position': {} };
  const popover = { ...{ position: 'relative', zIndex: '2' }, ...(popoverPositions[position] || {}) };
  const cover = { position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px' };

  return (
    <>
      <button type="button" data-tip={tooltip} className="color-picker-btn" onClick={onToggle} data-place={tooltipPosition}>
        <FontAwesomeIcon icon={['fal', 'fill']} />
        <FontAwesomeIcon icon={['fas', 'tint']} style={{ color }} />
      </button>
      {showColorPicker ? (
        <div style={popover}>
          <div style={cover} onClick={onClose} onKeyPress={() => {}} role="button" tabIndex={0} />
          {alphaOnly ? (
            <div {...ui([uiCard``, uiA`absolute p z-2 top-20 right`])}>
              <AlphaPicker
                onChangeComplete={onChangeComplete}
                color={
                  color.startsWith('#')
                    ? color
                    : zipObject(split('rgba', ''), map(split(replace(replace(color, 'rgba(', ''), ')', ''), ','), parseFloat))
                }
              />
            </div>
          ) : (
            <SketchPicker
              presetColors={[]}
              color={
                color.startsWith('#')
                  ? color
                  : zipObject(split('rgba', ''), map(split(replace(replace(color, 'rgba(', ''), ')', ''), ','), parseFloat))
              }
              onChangeComplete={onChangeComplete}
              disableAlpha={disableAlpha}
            />
          )}
        </div>
      ) : (
        ''
      )}
    </>
  );
}

Color.propTypes = {
  color: string,
  onChange: func.isRequired,
  position: string,
  tooltip: string,
  tooltipPosition: string,
  disableAlpha: bool,
};
